import { render, staticRenderFns } from "./AtfTile.vue?vue&type=template&id=d6c84444&"
import script from "./AtfTile.vue?vue&type=script&lang=js&"
export * from "./AtfTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports